import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import { TypeAsserter } from '@attain-apps/type-guards'

import * as state from '../../../../../../../../../../state'
import * as common from '../../../../../../common'

@ngCore.Component({
  imports: [
    common.glFilter.Component,
    ds.button.Component,
    ds.illustration.emptyState.Component,
    ds.input.checkbox.Component,
    ds.input.number.Component,
    ds.input.text.Component,
    ds.layout.section.Component,
  ],
  selector: 'atn-conditions-tab',
  standalone: true,
  styleUrls: ['./conditions-tab.component.scss'],
  templateUrl: './conditions-tab.component.html',
})
export class AtnConditionsTabComponent {
  /** @see {@link ngrxStore.Store} */
  private readonly _ruleEc = ngCore.inject(state.rate.gl.rules.Collection)
  /** @see {@link state.rate.gl.records.Collection} */
  private readonly _recordsEc = ngCore.inject(state.rate.gl.records.Collection)

  // Filtering attributes since attributes from attributes plugin also have some
  // properties that we wan't to show as attributes in glRecord table (such as
  // Code, Subcode, Exclusion etc.) but we don't consider them real attributes.
  public readonly attributesSg = ngCore.computed(() =>
    this._recordsEc.plugins.attributePlugin.feature.selectors.attributes
      .asSignal()
      .filter(
        attribute =>
          !state.rate.gl.common.attributes.mapping.Id.isId(attribute.id),
      )
      .map(attribute => ({
        label: attribute.name,
        value: attribute.id,
      })),
  )

  /**
   * Currently active `updating` or `creating`
   *
   * @see {@link ec.plugins.standard.plugins.editingPlugin.feature.actions.activeEditSl}
   */
  public editingRuleSg = ngCore.computed(
    (
      editingRule = this._ruleEc.plugins.currentEntityPlugin.feature.selectors
        .getEditedEntity()
        .asSignal(),
    ) => {
      // at this point editing rule can't be undefined.
      TypeAsserter.assertIsNotNullish(editingRule)

      return editingRule
    },
  )

  public ruleNameChangeHandler(name: string): void {
    const _rule = this.editingRuleSg()
    if (_rule) {
      this._ruleEc.plugins.editingPlugin.feature.actions.edit
        .from(
          'EditSlideout.Tabs.ConditionTab.Sections.General.RuleName.Changed',
        )
        .dispatch({
          edit: rule => {
            if (!rule) {
              return
            }
            rule.name = name
          },
        })
    }
  }

  public rulePriorityChangeHandler(priority: number): void {
    this._ruleEc.plugins.editingPlugin.feature.actions.edit
      .from('EditSlideout.Tabs.ConditionTab.Sections.General.Priority.Changed')
      .dispatch({
        edit: rule => {
          if (!rule) {
            return
          }
          rule.priority = priority
        },
      })
  }

  public ruleIsActiveChangeHandler(isActive: boolean): void {
    this._ruleEc.plugins.editingPlugin.feature.actions.edit
      .from('EditSlideout.Tabs.ConditionTab.Sections.General.IsActive.Clicked')
      .dispatch({
        edit: rule => {
          if (!rule) {
            return
          }
          rule.isActive = isActive
        },
      })
  }

  public filterChangeHandler(filter?: ents.extra.rate.gl.Filter) {
    if (filter) {
      this._ruleEc.plugins.editingPlugin.feature.actions.edit
        .from('EditSlideout.Tabs.ConditionTab.Sections.Criteria.Filter.Changed')
        .dispatch({
          edit: rule => {
            if (!rule) {
              return
            }
            rule.filter = filter
          },
        })
    }
  }
}
